import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import { usePostResultPayment } from '~/features/payment/queries/usePayment'
import ParticipationBackground from '~/shared/assets/background/home-participation.png'
import ParticipationMobileBackground from '~/shared/assets/background/home-participation-mobile.png'
import herne3 from '~/shared/assets/images/herne3.png'
import Button from '~/shared/components/buttons/Button'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

// TODO 실패 이미지 캐릭터 교체

function FailPage() {
  const navigate = useNavigate()
  const viewport = useViewport()
  const { mutate: postResultPaymentMutate } = usePostResultPayment()
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const orderId = searchParams.get('orderId')
  const message = searchParams.get('message')

  useEffect(() => {
    postResultPaymentMutate({
      paymentInfo: {
        success: false,
        order_code: orderId || '',
        error_code: code || '',
      },
    })
  }, [code, orderId])

  return (
    <Wrapper>
      <Container>
        <MainBox>
          <Title>결제 실패</Title>
        </MainBox>
        <SubText>{message ? message : '결제에 실패했습니다.'}</SubText>
        <Button
          $width={224}
          $height={58}
          $fontSize={24}
          $variant="transparent"
          onClick={() => {
            navigate('/')
          }}
        >
          돌아가기
        </Button>
        <BackgroundCharacter
          className="character"
          src={herne3}
          alt=""
          width={''}
          height={''}
        />
      </Container>
      <Background
        src={
          viewport < theme.deviceSizes.medium
            ? ParticipationMobileBackground
            : ParticipationBackground
        }
        alt="participation-background"
      />
    </Wrapper>
  )
}

export default FailPage

const Wrapper = styled.section`
  width: 100vw;
  min-height: calc(
    100vh - ${theme.size.headerHeight + theme.size.footerHeight}px
  );
  padding-top: ${theme.size.headerHeight}px;

  @media ${theme.device.medium} {
    height: auto;
    min-height: 700px;
    padding-top: ${theme.size.mobileHeaderHeight}px;
  }
`

const Container = styled.div`
  position: absolute;
  top: 40%;
  left: 30%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;

  width: 50%;
  margin: auto;

  .character {
    position: absolute;
    top: -100px;
    right: -70%;

    @media ${theme.device.medium} {
      right: 0;
    }
  }

  @media ${theme.device.medium} {
    position: relative;
    position: absolute;
    z-index: 99;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);

    gap: 24px;

    width: 90%;
  }
`

const Background = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowDefault};
  top: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;
`

const MainBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 60px;
  font-weight: 500;
  line-height: 84px;
  text-align: left;
  letter-spacing: -0.02em;

  @media ${theme.device.medium} {
    font-size: 36px;
  }
`

const SubText = styled.div`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 32px;

  @media ${theme.device.medium} {
    font-size: 21px;
  }
`

const BackgroundCharacter = styled.img`
  position: absolute;
  top: -100px;
  right: -70%;
  width: 600px;

  @media ${theme.device.medium} {
    z-index: -1;
    top: -200px;
    right: 0;
    width: 80%;
  }
`
